// Configuration for the AI Receptionist React App
const config = {
  // Backend API URL - Empty in dev (uses Vite proxy), set via VITE_API_URL in production
  backendUrl: import.meta.env.VITE_API_URL || '',
  
  // SignalR Hub endpoints
  hubs: {
    dashboard: '/hubs/dashboard',
    personalAI: '/hubs/personal-ai',
    agent: '/hubs/agent',
    calls: '/hubs/calls'
  },
  
  // Feature flags
  features: {
    enableAuth: false, // Set to true in production
    enableMockData: true,
    enableDebugLogs: true
  }
};

export default config;
